export default __webpack_public_path__ + "static/media/minimal-click.466e91fc.wav";